import { ConfigurePixel } from '../shared/configure-pixel';

export function OnboardingConfigurePixel() {
  return <ConfigurePixel buttonText="Continue" />;
}
